"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
const page_filter_state_1 = require("./model/page-filter-state");
const page_filter_helper_1 = require("./helper/page-filter-helper");
const filter_item_type_1 = require("./model/filter-item-type");
const filter_communication_key_1 = require("./model/filter-communication-key");
const operators_1 = require("rxjs/operators");
const Subject_1 = require("rxjs/Subject");
const idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
const idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
const reporting_filter_component_1 = require("../../controls/reporting-filter/reporting-filter.component");
const reporting_category_value_loader_1 = require("../../controls/reporting-filter/loader/reporting-category-value-loader");
const idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
const idm_um_client_js_1 = require("@synisys/idm-um-client-js");
const idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
const idm_me_client_js_1 = require("@synisys/idm-me-client-js");
const idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
let PageFilterComponent = class PageFilterComponent {
    constructor(communicationService, pathService, classifierService, userService, authenticationService, meCategoriesCommonService, currentLanguageProvider) {
        this.communicationService = communicationService;
        this.pathService = pathService;
        this.classifierService = classifierService;
        this.userService = userService;
        this.authenticationService = authenticationService;
        this.meCategoriesCommonService = meCategoriesCommonService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.FilterItemType = filter_item_type_1.FilterItemType;
        this.oldX = 0;
        this.width = 0;
        this.stateChange = new core_1.EventEmitter();
        this.destroy$ = new Subject_1.Subject();
        this.initPeersSubscription();
    }
    set state(state) {
        if (state !== this.pageFilterStateEmitted || !this.pageFilterStateEmitted) {
            this.pageFilterState = page_filter_state_1.PageFilterState.fromJSON(state);
            this.selectedPaths = this.pageFilterState.state;
            this.filterItems = page_filter_helper_1.convertPageFilterItemsToFilterItems(this.selectedPaths);
            if (this.datasetId != this.pageFilterState.datasetId) {
                this.datasetId = this.pageFilterState.datasetId;
                this.initValueLoader();
            }
        }
    }
    resizeTrigger(event) {
        if (this.isResizing) {
            this.resize(this.oldX - event.clientX);
            this.oldX = event.clientX;
            this.selectedPaths[this.resizingItemIndex].style.size = this.width;
        }
    }
    resizeTurnOff() {
        if (this.isResizing) {
            this.isResizing = false;
            this.resizingItemIndex = null;
            this.emitState();
        }
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    loadPaths() {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(this.datasetId);
        return this.pathService.getPaths(this.datasetId)
            .then((paths) => {
            let availablePaths = new Map();
            reporting_filter_component_1.ReportingFilterComponent.extractAvailablePaths(paths.categoryPaths, availablePaths);
            reporting_filter_component_1.ReportingFilterComponent.extractAvailablePaths(paths.measurePaths, availablePaths);
            return availablePaths;
        })
            .catch((err) => {
            console.error("Failed with the following error: %o", err);
            return Promise.reject(err);
        });
    }
    initValueLoader() {
        if (this.datasetId) {
            this.loadPaths()
                .then((paths) => {
                this.valueLoader = new reporting_category_value_loader_1.ReportingCategoryValueLoader(this.classifierService, this.userService, this.authenticationService, this.meCategoriesCommonService, this.currentLanguageProvider, paths);
            })
                .catch((err) => {
                console.error("Failed with the following error: %o", err);
            });
        }
    }
    resizeTurnOn(event, index) {
        this.resizingItemIndex = index;
        this.oldX = event.clientX;
        this.width = event.currentTarget.parentElement.clientWidth;
        this.selectedPaths[this.resizingItemIndex].style.size = this.width;
        this.isResizing = true;
        event.preventDefault();
        event.stopPropagation();
    }
    resize(offsetX) {
        this.width -= offsetX;
    }
    selectCell(index, selectedFilterItem) {
        this.selectedIndex = index;
        this.filterSelected = true;
        this.communicationService.peerSubject.next({
            key: filter_communication_key_1.FilterCommunicationKey.ON_FILTER_SELECT,
            index: index,
            selectedFilterItem: selectedFilterItem
        });
    }
    unselectCell() {
        this.communicationService.peerSubject.next({
            key: filter_communication_key_1.FilterCommunicationKey.ON_FILTER_UNSELECT
        });
    }
    clearSelectedState() {
        this.selectedIndex = null;
        this.filterSelected = false;
    }
    initPeersSubscription() {
        this.communicationService.peerObservable
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe((value) => {
            if (value.key === filter_communication_key_1.FilterCommunicationKey.ON_FILTER_UNSELECT) {
                this.clearSelectedState();
            }
        });
    }
    emitState() {
        this.pageFilterStateEmitted = this.pageFilterState.toJSON();
        this.stateChange.emit(this.pageFilterStateEmitted);
        this.preview();
    }
    preview() {
        let communicationData = new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.PREVIEW);
        this.communicationService.parentSubject.next(communicationData);
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PageFilterComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], PageFilterComponent.prototype, "state", null);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], PageFilterComponent.prototype, "stateChange", void 0);
__decorate([
    core_1.HostListener('document:mousemove', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PageFilterComponent.prototype, "resizeTrigger", null);
__decorate([
    core_1.HostListener('document:mouseup', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], PageFilterComponent.prototype, "resizeTurnOff", null);
PageFilterComponent = __decorate([
    core_1.Component({
        
        selector: 'sis-page-filter',
        template: require('./page-filter.component.html'),
        styles: [require('./page-filter.component.css')]
    }),
    idm_dynamic_controls_metadata_1.ControlMetadata({
        template: `<sis-page-filter [id]="controlId" [state]='%{state}' (stateChange)='%{stateChange}'></sis-page-filter>`
    }),
    __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService,
        idm_dataset_service_client_js_1.PathService,
        idm_classifier_service_client_js_1.ClassifierService,
        idm_um_client_js_1.UserService,
        idm_authentication_client_js_1.AuthenticationService,
        idm_me_client_js_1.CommonServicesProviderService,
        idm_session_data_provider_api_js_1.CurrentLanguageProvider])
], PageFilterComponent);
exports.PageFilterComponent = PageFilterComponent;
//# sourceMappingURL=page-filter.component.js.map